import { render, staticRenderFns } from "./PaymentsAddressed.vue?vue&type=template&id=05683e9c&"
import script from "./PaymentsAddressed.vue?vue&type=script&lang=js&"
export * from "./PaymentsAddressed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports